export enum Environment {
  Dev = 'dev',
  Perfomance = 'perf',
  Release = 'release',
  Production = 'prod',
}

export enum ReservationSlotState {
  Available = 1,
  Unavailable = 2,
}

export enum ReservationSlotStatus {
  Unspecified = 0,
  Schedulable = 1,
  Committed = 2,
  Uncommitted = 3,
  Break = 4,
  Holiday = 5,
  Vacation = 6,
  Appointment = 7,
}

export enum RenovationExecutor {
  Organization = 752560000,
  Person = 752560001,
  PortalUser = 752560002,
  ForeignCompany = 752560003,
}

export enum BoardMemberStatuses {
  Planned = 2,
  Open = 3,
  InProgress = 4,
  Overdue = 7,
  Completed = 5,
  Canceled = 6,
}

export enum CaseStatuses {
  InProgress = 1,
  InHandling = 752560001,
  Approved = 752560002,

  // Resolved
  Completed = 752560003,

  // Canceled
  Canceled = 6,
  Rejected = 752560004,
}

export enum CaseStateCode {
  Active = 0,
  Resolved = 1,
  Canceled = 2,
}

export enum CaseRequestTypes {
  Problem = 752560001,
  DeviceFailure = 752560011,
  Inquiry = 752560000,
  Request = 752560002,
  Notice = 752560003,
  Reclamation = 752560004,
  Initiative = 752560005,
  Order = 752560006,
  Disturbance = 752560007,
  Project = 752560008,
  KeyOrder = 752560009,
  PTS = 752560010,
  SpaceRenovationRequest = 100000000,
  YearlyReportMajorActivities = 752560012,
  WarrantyRepair = 100000001,
}

export enum RepairStatuses {
  InProgress = 1,
  InHandling = 752560001,
  Approved = 752560002,

  Completed = 752560003,

  Canceled = 6,
  Rejected = 752560004,
}

export enum TaskStatusCode {
  //Open
  Planned = 2,
  Open = 3,
  InProgress = 4,
  Overdue = 7,

  //Completed
  Completed = 5,

  //Canceled
  Canceled = 6,
}

export enum NotificationTypeCode {
  Internal = 100000000,
  PortalNotification = 100000001,
  PortalFrontPage = 752560001,
  CRM = 752560000,
}

export enum NotificationType {
  UserSpace = 'user_space',
  Chat = 'chat',
  Bell = 'bell',
  Messages = 'messages',
  BoardMessages = 'board_messages',
}

export enum NotificationEntities {
  EventInformation = 'uds_eventinformation',
  Incident = 'incident',
  Task = 'task',
}

export enum PortalsName {
  Default = 'Default',
  Maintenance = 'Maintenance',
  Investor = 'Investor',
}

export enum EntityType {
  BoardEventsInformation = 'board_eventsinformation',
  EventsInformation = 'eventsinformation',
  Incident = 'incident',
  KeyOrder = 'key_order',
  Repair = 'repair',
  Task = 'task',
}

export enum RequestTypeCode {
  Case = 752560013,
  SpaceRenovationRequest = 100000000,
  KeyOrder = 752560009,
  PTS = 752560010,
}

export enum CaseExternalStatusCode {
  Active = 1,
  Expired = 2,
  Inactive = 3,
  NoTasks = 4,
  Completed = 5,
  Canceled = 6,
}

export enum InvoiceDirection {
  Outgoing = 752560000,
  Incoming = 752560001,
}

export enum BalanceType {
  All = 3,
  Prepayments = 0,
  Receivables = 1,
  PrepaymentsAndReceivables = 2,
  Opening = 4,
}
